
import img1 from '../images/logo/brand0.png'
import img2 from '../images/logo/brand1.png'
import img3 from '../images/logo/brand2.png'
import img4 from '../images/logo/brand4.png'
import img5 from '../images/logo/brand3.png'
import img6 from '../images/logo/brand5.png'


const dataPartner = [

    {
        id: 1,
        img: img1,
    },
    {
        id: 2,
        img: img2,
    },
    {
        id: 3,
        img: img3,
    },
    {
        id: 4,
        img: img4,
    },
    {
        id: 5,
        img: img6,
    },
    {
        id: 6,
        img: img5,
    },

]

export default dataPartner;